<template>
  <div class="code-editor">
    <span v-if="label" class="code-editor__label">{{ label }}</span>
    <highlightjs
      :class="['code-editor__input', { 'm-fixedHeight': fixedHeight }]"
      autodetect
      :code="code"
    />
  </div>
</template>

<script>
import "highlight.js/styles/atom-one-light.css";
import hljsVuePlugin from "@highlightjs/vue-plugin";

export default {
  name: "CodeEditor",
  components: {
    highlightjs: hljsVuePlugin.component,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.code-editor {
  display: grid;
  gap: 10px;

  &__label {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: var(--color-secondary-500);
  }

  &__input {
    padding: 20px;
    border: 2px solid var(--color-secondary-400);
    border-radius: 8px;

    &.m-fixedHeight {
      overflow-y: auto;
      max-height: 200px;
    }
  }
}

.hljs {
  background: transparent !important;
  padding: 0 !important;
  white-space: pre-wrap;
}
</style>
